import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { commonErrorMessage } from "../../../helpers/messages";
import { getLabTestRecordsByClientId } from "../../../api/labTest";
import { ILabRecord } from "../../../interfaces/Lab";
import GroupLabsByDate from "../functions/labs";
import dispatchNotification from "../actions/dispatchNotification";

const useClientLabs = (): { labs: { [key: string]: ILabRecord[] }; isLoading: boolean } => {
  const dispatch = useDispatch();
  const [labTests, setLabTests] = React.useState<ILabRecord[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const clientId = useSelector((state: RootState) => state.clientPortalUserInfo.user.user.id);
  React.useEffect(() => {
    (async () => {
      if (clientId) {
        try {
          setIsLoading(true);
          const labData = (await getLabTestRecordsByClientId(clientId, {
            page: 0,
            pageSize: 10,
            labRecordType: "all"
          })) as { results: ILabRecord[] };
          setLabTests(labData.results);
        } catch {
          dispatchNotification.error(dispatch, commonErrorMessage);
          setIsLoading(false);
        } finally {
          setIsLoading(false);
        }
      }
    })();
  }, [clientId, dispatch]);

  return { labs: GroupLabsByDate(labTests), isLoading };
};

export default useClientLabs;
